import { ApiErrorAlertBox } from '@/components/ApiAlertBox/ApiErrorAlertBox'
import { AlertCard } from '@/features/notifications/components/AlertCard'
import { useAlertDetails } from '@/features/notifications/hooks/useAlerts'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/$companySlug/notification-center/$alertId'
)({
  beforeLoad: ({ context }) => {
    context.auth.rejectIfMissingPermissions(['NOTIFICATION_READ'])
  },

  component: AlertDetail
})

function AlertDetail() {
  const navigate = Route.useNavigate()
  const { alertId } = Route.useParams()
  const { data: alertDetails, error } = useAlertDetails(alertId)

  const handleClose = () => {
    navigate({
      to: '/$companySlug/notification-center'
    })
  }
  return (
    <>
      <ApiErrorAlertBox error={error} />
      {alertDetails && <AlertCard alert={alertDetails} onClose={handleClose} />}
    </>
  )
}
